import { render, staticRenderFns } from "./ShowPhoto.vue?vue&type=template&id=407afbfa&lang=pug"
import script from "./ShowPhoto.vue?vue&type=script&lang=js"
export * from "./ShowPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports